/**
 * Hat sich Martin in DIESEM Zug verabschiedet? (27.09.2026, Ticket 2701)
 *
 * Martin: *„Wenn ich mich am Ende eines Gesprächs verabschiede („tschüss“,
 * „das wär's“, „bis später“), soll das System das erkennen und danach das
 * Mikro NICHT mehr automatisch öffnen.“*
 *
 * Erkannt wird es vom MODELL über das Werkzeug gespraech_beenden
 * (tools/gespraech-ende.ts), nicht an Wörtern. Hier steht nur der Merker.
 *
 * ⚠️ EIN Besitzer: nur diese Datei schreibt ihn. Er gilt für DIESEN Zug —
 *    eroeffneZug (app.ts) setzt ihn zurück, der Hörer am Vorlese-Ende löst
 *    ihn einmal ein. Ein unterbrochener Abschied meldet kein Vorlese-Ende
 *    (`tts-audio-abbruch`); ohne den Rücksatz beim nächsten Zug bliebe der
 *    Merker stehen und hielte dessen Fenster zu.
 */

import { ENDE_WERKZEUG, ohneVorsatz } from "../../shared/gespraech-ende.js";

/** Das Werkzeug, mit dem das Modell den Abschied meldet — der Name steht in shared/. */
export { ENDE_WERKZEUG };

let verabschiedet = false;
/** Welle 1: das Signal kam von Jev (Ergebnis trägt `abgeleitet`), nicht aus Martins ausdrücklichem Ende (Modell, Taste). */
let abgeleitet = false;

/** Ein neuer Zug beginnt ohne Abschied. */
export function zugOhneAbschied(): void {
  verabschiedet = false;
  abgeleitet = false;
}

/** Nach jedem Werkzeug-Ergebnis: ein gelungener Abschied gilt für diesen Zug. */
export function merkeAbschied(tool: string, isError: boolean, result?: unknown): void {
  if (ohneVorsatz(tool) !== ENDE_WERKZEUG || isError) return;
  const jev = (result as { abgeleitet?: unknown } | null | undefined)?.abgeleitet === true;
  // Ein ausdrückliches Ende (ohne Marke) gilt immer; ein abgeleitetes überschreibt es nie.
  abgeleitet = verabschiedet ? abgeleitet && jev : jev;
  verabschiedet = true;
}

/** Nur ansehen: war das Signal dieses Zugs von Jev abgeleitet (und kein ausdrückliches Ende)? */
export function abschiedAbgeleitetAnsehen(): boolean {
  return verabschiedet && abgeleitet;
}

/** Nur ansehen, nichts löschen (Mikro-Vorstart, mikro-vorstart.ts): hat er sich in diesem Zug verabschiedet? */
export function abschiedAnsehen(): boolean {
  return verabschiedet;
}

/** Am Vorlese-Ende: hat er sich verabschiedet? Einmal gelesen, dann gelöscht. */
export function abschiedEinloesen(): boolean {
  return abschiedEinloesenArt().verabschiedet;
}

/** Wie `abschiedEinloesen`, dazu: war es nur von Jev abgeleitet? Einmal gelesen, dann gelöscht. */
export function abschiedEinloesenArt(): { verabschiedet: boolean; abgeleitet: boolean } {
  const r = { verabschiedet, abgeleitet: verabschiedet && abgeleitet };
  verabschiedet = false;
  abgeleitet = false;
  return r;
}
